//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.NcmEngRetBuilder.js";
import "../CAM/CAM.ToolPathSplitParametersBuilder.js";
let d=[[[0,"ClearancePlane",1,"NXObject",0],[0,"DistanceLimit",1,0],[0,"DivideType",1,0],[1,"NcmEngageRetractBuilder",0,"CAM.NcmEngRetBuilder",0],[0,"NumberOfDivideEvents",0,0],[0,"TimeLimit",1,0],[0,"TolerancePercent",1,0],[1,"ToolPathSplitParametersBuilder",0,"CAM.ToolPathSplitParametersBuilder",0],[0,"UdeEndOfPath",1,"NXObject",0],[0,"UdeStartOfPath",1,"NXObject",0]],[[["n_out_events"],"GetAllDivideEvents",{R_:{divide_events:""}},0,0],[[],"RemoveAllDivideEvents",{},0,0],[["divide_event"],"AddDivideEvent",{},1,0],[["index"],"GetDivideEvent",{R_:{divide_event:''}},1,0],[["divide_event"],"RemoveDivideEvent",{},1,0]],[]];
SPLM.CAM.ToolPathDivideBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolPathDivideBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolPathDivideBuilder.PathDivideType = Object.freeze({
    "ByTime" : "ByTime", "ByDistance" : "ByDistance", "ByEvents" : "ByEvents"});

export default SPLM;